import { TextProps, TextPropsTextConfig } from '@features/powerpoint';
import { TAGS_METADATA, tagRegex } from '@features/powerpoint/utils/tags';
import { unifiedPlatformColorPalette } from '@utils/unifiedPlatformColorPalette';

type Tag = {
  tag: string;
  description: string;
  style: TextProps['options'];
};

const TAGS = TAGS_METADATA.map(tagMetadata => {
  switch (tagMetadata.tag) {
    case 'b': {
      return {
        ...tagMetadata,
        style: {
          bold: true,
        },
      };
    }
    case 'u': {
      return {
        ...tagMetadata,
        style: {
          underline: { style: 'sng' },
        },
      } as Tag;
    }
    case 'i': {
      return {
        ...tagMetadata,
        style: {
          italic: true,
        },
      };
    }
    case 'sup': {
      return {
        ...tagMetadata,
        style: {
          sup: true,
        },
      } as Tag;
    }
    case 'lci': {
      return {
        ...tagMetadata,
        style: {
          bold: true,
          color: unifiedPlatformColorPalette.inmarketGreen,
        },
      };
    }
    case 'vr': {
      return {
        ...tagMetadata,
        style: {
          bold: true,
          color: unifiedPlatformColorPalette.lightBlue,
        },
      };
    }
    default: {
      return tagMetadata;
    }
  }
}) satisfies Tag[];

/** @deprecated in favor of parseTags */
export const parseContent = (
  text: string,
  tagIndex = 0,
  appliedStyles: TextProps['options'] = {}
): TextPropsTextConfig[] => {
  if (tagIndex >= TAGS.length) {
    return text && text.length > 0
      ? [
          {
            text,
            options: appliedStyles,
          },
        ]
      : [];
  }

  const tagConfig = TAGS[tagIndex];
  if (!tagConfig) {
    const message = `No tag configuration found for index ${tagIndex}`;
    console.error(message);
    throw new Error(message);
  }
  const { tag, style } = tagConfig;
  const textItems = text.split(tagRegex(tag));
  const contentItems = textItems.map((textItem, index) => {
    const nextAppliedStyles =
      index % 2 === 0 ? appliedStyles : { ...appliedStyles, ...style };
    return parseContent(textItem, tagIndex + 1, nextAppliedStyles);
  });

  return contentItems.flat();
};
